import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);

const isoDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const isoDateOnlyFormat = 'YYYY-MM-DD';
const dateOnlySlashesFormat = 'MM/DD/YYYY';
const dateTimeSlashesFormat = 'MM/DD/YYYY h:mm A';

const formatUtcDate = ({ date, format = dateOnlySlashesFormat }) => {
    if (!date) {
        return null;
    }

    return dayjs.utc(date).format(format);
};

const formatDate = (date, format = dateOnlySlashesFormat) => {
    if (!date) {
        return null;
    }
    return dayjs(date).format(format);
};

function toUtc(date) {
    if (typeof date === 'string' && date.length >= 10 && date !== '0000-00-00 00:00:00') {
        return dayjs.utc(date).toDate();
    }
    return null;
}

export function toDate(dateInput) {
    if (!dateInput) {
        return null;
    }
    return dayjs(dateInput).toDate();
}

export {
    isoDateOnlyFormat,
    isoDateTimeFormat,
    dateOnlySlashesFormat,
    dateTimeSlashesFormat,
    formatUtcDate,
    formatDate,
    toUtc,
};
